
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRTotals({
  shop,
  totals,
}) {
  return (
    <TableContainer>
    <Table size="small">
      <TableBody>
        <TableRow
          sx={{
            bgcolor: "primary.light",
            "& td": {
              fontWeight: 700,
              borderTop: "2px solid",
              borderColor: "primary.main",
              whiteSpace: "nowrap",
              
            },
          }}
        >

         

          <TableCell align="left" >
           {shop}  Total
          </TableCell>


          <TableCell align="right"  >
            <CurrencyCell
              value={totals.actual_L}
            />
          </TableCell>

          <TableCell align="right"  >
            <CurrencyCell
              value={totals.dist_L}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.ou_LL}
            />
          </TableCell>

          
 <TableCell align="right"  >
            <CurrencyCell
              value={totals.actual_S}
            />
          </TableCell>

          <TableCell align="right"  >
            <CurrencyCell
              value={totals.dist_S}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.ou_SS}
            />
          </TableCell>

        </TableRow>
      </TableBody>
    </Table>
    </TableContainer>
  );
}

